import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 40 40" {...props}>
    <rect x="8.134" y="5.94" width="2" height="26.255" />
    <rect x="8.196" y="30.195" width="26.255" height="2" />
    <polygon points="9.812,25.398 8.581,23.822 15.832,18.154 19.563,21.574 30.312,12.631 31.591,14.168 19.5,24.229 15.729,20.773 " />
    <polygon points="20.448,19.022 16.754,15.292 9.944,15.292 9.944,13.292 17.588,13.292 21.869,17.615 " />
    <rect
      x="23.668"
      y="23.599"
      transform="matrix(0.7071 0.7071 -0.7071 0.7071 25.3934 -12.1069)"
      width="7.285"
      height="2"
    />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/Analytics.jsx